import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ResponsiveLine } from '@nivo/line';

import '../../assets/stylesheets/DashboardView.css';

class LineGraph extends Component {
  render() {
    const { data, useCustomColors } = this.props;

    return (
      <div className="lineContainer">
        <ResponsiveLine
          data={data}
          margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
          xScale={{ type: 'point' }}
          yScale={{
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: true,
            reverse: false
          }}
          axisTop={null}
          axisRight={null}
          axisLeft={{
            orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'count',
            legendOffset: -40,
            legendPosition: 'middle'
          }}
          colors={useCustomColors ? d => d.color : { scheme: 'nivo' }}
          lineWidth={4}
          pointSize={7}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabel="y"
          pointLabelYOffset={-12}
          useMesh
          legends={[
            {
              anchor: 'right',
              direction: 'column',
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: 'left-to-right',
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: 'circle',
              symbolBorderColor: 'rgba(0, 0, 0, .5)',
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemBackground: 'rgba(0, 0, 0, .03)',
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
        />
      </div>
    );
  }
}

LineGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  useCustomColors: PropTypes.bool.isRequired
};

export default LineGraph;
